module.exports = __webpack_public_path__ + "img/paragraph.6ca3d092.svg";